var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecenterMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20V15.402L8.015 16.881L7.308 16.173L10 13.481L12.692 16.173L11.984 16.881L10.5 15.402V20H9.5ZM3.827 12.692L3.119 11.985L4.598 10.5H0V9.5H4.598L3.119 8.015L3.827 7.308L6.519 10L3.827 12.692ZM16.173 12.692L13.481 10L16.173 7.308L16.881 8.016L15.402 9.5H20V10.5H15.402L16.881 11.985L16.173 12.692ZM10 10.981C9.72467 10.981 9.49233 10.8863 9.303 10.697C9.11367 10.5083 9.019 10.276 9.019 10C9.019 9.724 9.11367 9.49167 9.303 9.303C9.49233 9.11367 9.72467 9.019 10 9.019C10.2753 9.019 10.5077 9.11367 10.697 9.303C10.8863 9.49233 10.981 9.72467 10.981 10C10.981 10.2753 10.8863 10.5077 10.697 10.697C10.5077 10.8863 10.2753 10.981 10 10.981ZM10 6.519L7.308 3.827L8.016 3.119L9.5 4.598V0H10.5V4.598L11.985 3.119L12.692 3.827L10 6.519Z",
    fill: "#808080"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5,
    stroke: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecenterMap);
export default __webpack_public_path__ + "static/media/icon-recenter-map.2fec77adac63eac982d44f6d5c380afb.svg";
export { ForwardRef as ReactComponent };